import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49ee7212"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalPost",
  tabindex: "-1",
  "aria-labelledby": "editPost",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header align-items-start" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_6 = { class: "user d-flex align-items-center" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "fs-8 date-text"
}
const _hoisted_11 = {
  key: 1,
  class: "fs-8 date-text"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "postCloseButton",
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_13 = { class: "modal-body" }
const _hoisted_14 = { class: "content border-bottom position-relative mb-4" }
const _hoisted_15 = { class: "content__main pb-4" }
const _hoisted_16 = {
  key: 0,
  class: "fw-bold mb-4 fs-9"
}
const _hoisted_17 = {
  key: 1,
  class: "ql-snow"
}
const _hoisted_18 = { class: "ql-editor only-view-editor no-padding" }
const _hoisted_19 = ["src", "width", "height"]
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center mb-lg-5 mb-3"
}
const _hoisted_22 = {
  key: 2,
  class: "position-relative"
}
const _hoisted_23 = { class: "ql-snow" }
const _hoisted_24 = { class: "ql-editor only-view-editor no-padding community-site-post-content" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 3,
  class: "flex ml-auto mb-4"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-button-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-button-text" }, "詳しくはこちら"),
  /*#__PURE__*/_createElementVNode("button", { class: "circle-button" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" })
  ])
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-button-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-button-text" }, "詳しくはこちら"),
  /*#__PURE__*/_createElementVNode("button", { class: "circle-button" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" })
  ])
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 4,
  class: "d-flex flex-column mb-4 border-top border-bottom mt-2 py-0 url-container"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "d-flex flex-column" }
const _hoisted_36 = {
  key: 0,
  class: "mb-4 d-flex flex-wrap"
}
const _hoisted_37 = {
  key: 1,
  class: "d-flex btn-container justify-content-sm-end mb-4"
}
const _hoisted_38 = {
  key: 2,
  class: "file-container d-flex justify-content-between align-items-center"
}
const _hoisted_39 = { class: "d-flex align-items-center text-truncate" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_41 = { class: "mb-0 text-truncate" }
const _hoisted_42 = {
  key: 0,
  class: "d-flex justify-content-end mb-4"
}
const _hoisted_43 = { class: "d-flex justify-content-center mt-3" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Category from '@/components/category/category-admin.vue'
import HashTag from '@/components/hash-tag/index.vue'
import LikeButton from '@/components/like-button/LikeAdmin.vue'
import Comment from '@/views/shared/communities/components/Comment.vue'
import Avatar from '@/components/avatar/index.vue'
import UserComments from '@/views/community-admin/post-management/components/UserComments.vue'
import { ChangeTime } from '@/constants/datepicker'
import { MODAL_ID, ReplayName } from '@/constants/common'
import { addPostParams } from '@/use/usePath'
import TargetTag from '@/components/target-tag/index.vue'
import { computed, ComputedRef, ref, watchEffect, onMounted, PropType, watch } from 'vue'
import dayjs from 'dayjs'

import { ACCOUNT_STORE, USER_POST_STORE } from '@/store/constants'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/ja'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { ROOT_STORE } from '@/store/constants'
import postService from '@/services/post.services'
import PostFileDownload from '@/views/shared/communities/components/PostFileDownload.vue'
import { Modal } from 'bootstrap'
import { isEmpty } from 'lodash'
import { changeModalElevation, escapeHtml } from '@/utils'
import { AxiosError } from 'axios'
import { RECORD_NOT_FOUND } from '@/constants'
import { useToast } from 'vue-toastification'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import UrlDisplay from '@/components/post-url/UrlDisplay.vue'
import { getUnicodeLength, sliceUnicode } from '@/utils'
import { editorTrimBottomOnlyNewLine } from '@/views/community-admin/community-site/constants'
import { EDITOR_EMPTY_TAG_REGEX } from '@/constants/regex'
import { purifyContent } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  postId: {
    type: Number,
  },
  ref: null,
  userPost: Boolean,
  onInterestClick: { type: Function as PropType<() => void | undefined>, required: true },
  listUser: {
    type: Array,
  },
  listUserMention: {
    type: Object,
  },
},
  emits: ['setCommentData', 'showDeleteCommentModal', 'showUpdateCommentErrorModal', 'showUpdateStatusCommentModal'],
  setup(__props, { expose, emit }) {

const props = __props

dayjs.locale('ja')

dayjs.extend(relativeTime)



const store = useStore()
const route = useRoute()
const toast = useToast()

const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const postDetail = computed(() => store.getters[USER_POST_STORE.GETTERS.GET_POST_DETAIL])
const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)
const postComment = ref()
const post = ref()
const modal = ref()
const idComment = ref(null)

const titleMention = computed(() => {
  if (route.path.includes('operational_posts')) {
    return translate('titleMentionCT10')
  } else if (route.path.includes('user_posts')) {
    return translate('titleMentionOF')
  } else {
    return ''
  }
})

const mentionUsers = computed(() => {
  if (props.listUserMention?.data) {
    return props.listUserMention.data.filter((item: any) => item.id !== props.listUserMention.current_user_id)
  }

  return []
})

const setCommentData = (post_id, id, published) => {
  emit('setCommentData', post_id, id, published)
}

const showDeleteCommentModal = () => {
  emit('showDeleteCommentModal')
}

const showUpdateCommentErrorModal = () => {
  emit('showUpdateCommentErrorModal')
}



const showUpdateStatusCommentModal = () => {
  emit('showUpdateStatusCommentModal')
}

watchEffect(() => {
  post.value = postDetail.value.post
  postComment.value = post.value?.comments
})

const handleShowUser = async (id, userID, userType, is_deleted_in_30_days) => {
  if (userType === 'community_admin' || is_deleted_in_30_days === 2) {
    return
  }

  modal.value = new Modal(document.getElementById(userType === 'alumni' ? 'editProfileModal' : 'profileUserModal'))
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id, userID, userType, isAdmin: true })
  if (showModal.value) {
    await modal.value?.show()
  }
}
const loadingLike = ref<boolean>(false)

const handleLikeOrInterest = async (type: 'like' | 'interest', id: any): void => {
  // 2022/09/13 TienNV Fix double click button interest
  loadingLike.value = true

  const newPost = postDetail.value.post
  const likeAndInterestActionObj = {
    like: {
      true: async () => await postService.likePost(id, { create_by_admin: true }),
      false: async () => await postService.disLikePost(id, { create_by_admin: true }),
    },
    interest: {
      true: async () => await postService.interestPost(id, { create_by_admin: true }),
      false: async () => await postService.disInterestPost(id, { create_by_admin: true }),
    },
  }
  try {
    const data = await likeAndInterestActionObj[type][`${'' + !newPost[type]}`]()
    if (data.data?.success) {
      if (type === 'interest') {
        changeModalElevation('modalPost', 'backdrop')

        const element = document.getElementById(MODAL_ID.INTEREST_COMPLETE)
        element?.addEventListener('hide.bs.modal', () => {
          changeModalElevation('modalPost', 'higher')
        })
        new Modal(element)?.show()
      }

      store.dispatch(USER_POST_STORE.ACTIONS.UPDATE_LIKE_INTEREST_POST, {
        ...newPost,
        [type]: !newPost[type],
        [`${type}_count`]: newPost[type] ? --newPost[`${type}_count`] : ++newPost[`${type}_count`],
      })
      setTimeout(() => {
        loadingLike.value = false
      }, 500)
    } else {
      // Prevent cases of resource has been deleted before but user still can
      // interact with its reference --> api can't found resource --> redirect user to 404 page
      const errorResponse = (data as unknown as AxiosError).response
      if (!errorResponse?.data?.success && errorResponse?.data?.data[0]?.status === 404 && errorResponse?.data?.data[0]?.message_code === RECORD_NOT_FOUND) {
        // Show toast
        toast.error({
          component: ErrorToast,
          props: {
            messageCode: 'OF10errorStatusHasChange',
          },
        })
        // Close current modal
        document.getElementById('postCloseButton')?.click()
        // Remove from list
        await store.dispatch(USER_POST_STORE.ACTIONS.REMOVE_POST, { postId: id })
      }
    }
  } catch (error) {
    console.log(error)
    loadingLike.value = false
  }
}

const checkUserDeleted = (post: any) => {
  return props?.userPost && !(!post?.available || [1, 2].includes(post?.is_deleted_in_30_days))
}
const reset = ref<number>(0)
const resetComment = () => {
  reset.value++
}
onMounted(() => {
  idComment.value = route.query?.target_content_id
  window.addEventListener('hidden.bs.modal', function () {
    resetComment()
  })
})
const showUrlInConfirmDialog = () => !isEmpty(post.value.site_name_1) || !isEmpty(post.value.site_url_1) || !isEmpty(post.value.site_name_2) || !isEmpty(post.value.site_url_2)

expose({
  handleLikeOrInterest,
})

const communitySitePostContent = computed(() => {
  if (post.value?.content_type === 5) {
    return getCommunitySiteContent(post.value?.content)
  } else {
    return {}
  }
})

const openUrlAssignToImage = (url: string) => {
  if (!url) return
  const formattedUrl = /^(http|https):\/\//.test(url) ? url : `https://${url}`
  window.open(formattedUrl, '_blank')
}

const getCommunitySiteContent = (content) => {
  if (!content) {
    return {}
  }

  // Create a temporary DOM element to parse the HTML content
  var tempDiv = document.createElement('div')
  tempDiv.innerHTML = purifyContent(content)

  // Traverse the original HTML and reconstruct up to the limit 100 characters
  var currentLength = 0
  var maxLength = 100
  var result = ''
  var reachedLimit = false

  var firstImageUrl = ''
  var checkGetImageSuccess = false
  let imageWrapClassName = ''
  let urlAssignToImage = ''
  var hasMoreContentThanLimit = false
  // Since image can be resize in editor
  // imageWidth and height need to be preserved if it has value
  let imageWidth = 0
  let imageHeight = 0

  // Get first img
  if (tempDiv.getElementsByTagName('img')?.length > 0) {
    const imageNode = tempDiv.getElementsByTagName('img')[0]
    firstImageUrl = imageNode.getAttribute('src')
    if (imageNode.hasAttribute('width')) {
      imageWidth = imageNode.getAttribute('width')
      imageHeight = imageNode.getAttribute('height')
    }
    let { nodeName } = imageNode.parentNode
    // In case of image has hyperlink attach to its,
    // then must recursively take style of <a>'s parent element
    if (nodeName === 'A') {
      urlAssignToImage = imageNode.parentNode.getAttribute('href')
    }
    imageWrapClassName = 'ql-align-center'
    checkGetImageSuccess = true
  }

  function traverse(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var textContent = node.textContent
      const textContentLength = getUnicodeLength(textContent)
      // Check if adding this text node would exceed maxLength
      if (currentLength + textContentLength > maxLength) {
        // Slice the text content up to the remaining allowed length
        result += sliceUnicode(textContent, maxLength - currentLength)
        if (!reachedLimit) {
          reachedLimit = true
          result += '...' // Only add ellipsis if truncation occurs
          hasMoreContentThanLimit = true
        }
        currentLength = maxLength
      } else {
        result += textContent
        currentLength += textContentLength
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // Skip the img tag or stop if limit is reached
      if (node.tagName.toLowerCase() === 'img' || reachedLimit) {
        return
      }
      if (node.tagName.toLowerCase() === 'br') {
        if (currentLength < maxLength) {
          currentLength += 1
        }
        return
      }
      // Append opening tag
      result += '<' + node.tagName.toLowerCase()
      for (var i = 0; i < node.attributes.length; i++) {
        result += ' ' + node.attributes[i].name + '="' + node.attributes[i].value + '"'
      }
      result += '>'

      // Recursively process the child nodes
      for (var j = 0; j < node.childNodes.length; j++) {
        traverse(node.childNodes[j])
        if (currentLength >= maxLength) {
          if (!reachedLimit && hasMoreContentThanLimit) {
            reachedLimit = true
            result += '...' // Add ellipsis if content is truncated, not if exactly at limit
          }
          return // Stop processing further once limit is reached
        }
      }

      // Append closing tag
      if (node.tagName.toLowerCase() !== 'br') {
        result += '</' + node.tagName.toLowerCase() + '>'
      }
    }
  }

  const traverse2 = (node) => {
    let openTag = ''
    let removeOpenTag = false
    if (node.nodeType !== Node.TEXT_NODE && node.tagName.toLowerCase() !== 'img') {
      openTag = '<' + node.tagName.toLowerCase()
      for (let i = 0; i < node.attributes.length; i++) {
        openTag += ' ' + node.attributes[i].name + '="' + node.attributes[i].value + '"'
      }
      openTag += '>'
      result += openTag
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const textContent = node.textContent
      const textContentLength = getUnicodeLength(textContent)

      if (textContentLength > 0 && currentLength === maxLength) {
        reachedLimit = true
        result += '...'
      } else {
        if (currentLength + textContentLength > maxLength) {
          const slice = sliceUnicode(textContent, maxLength - currentLength)
          result += escapeHtml(slice)
          if (!reachedLimit) {
            reachedLimit = true
            result += '...'
          }
          currentLength = maxLength
        } else {
          result += escapeHtml(textContent)
          currentLength += textContentLength
        }
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.tagName.toLowerCase() === 'br') {
        if (currentLength >= maxLength) {
          const lastIdx = result.lastIndexOf(openTag)
          result = result.substring(0, lastIdx)
          removeOpenTag = true
        }
      } else {
        node.childNodes.forEach((child) => {
          if (!reachedLimit) {
            traverse2(child)
          }
        })
      }
    }

    if (node.nodeType !== Node.TEXT_NODE && node.tagName.toLowerCase() !== 'img') {
      if (!removeOpenTag) {
        if (node.tagName.toLowerCase() !== 'br') {
          result += '</' + node.tagName.toLowerCase() + '>'
        }
      }

      if ('h1|h2|li|p|blockquote|div'.includes(node.tagName.toLowerCase())) {
        currentLength += 1
        if (currentLength >= maxLength && !reachedLimit) {
          reachedLimit = true
          const { content: trimBottom } = editorTrimBottomOnlyNewLine(result, [EDITOR_EMPTY_TAG_REGEX])
          result = trimBottom
          result += '...'
        }
      }
    }
  }

  // Start traversing from the actual child nodes of tempDiv to skip the div itself
  // tempDiv.childNodes.forEach((child) => traverse(child))
  traverse2(tempDiv)
  if (checkGetImageSuccess) {
    return {
      content: result,
      image_url: firstImageUrl,
      image_wrap_class_name: imageWrapClassName,
      url_assign_to_image: urlAssignToImage,
      image_size: {
        width: imageWidth,
        height: imageHeight,
      },
    }
  } else {
    return {
      content: result,
    }
  }
}

watch(
  () => post.value,
  async () => {
    if (post.value?.content_type === 5) {
      setTimeout(() => {
        const linkableComponents = document.querySelectorAll('.community-site-post-content a')
        linkableComponents.forEach((linkableComponent) => {
          linkableComponent.setAttribute('target', '_blank')
        })
      }, 300)
    }
  },
  {
    deep: true,
    immediate: true,
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createVNode(Avatar, {
                  is_deleted_in_30_days: post.value?.is_deleted_in_30_days,
                  user_image_url: post.value?.user_image_url,
                  userType: __props.userPost ? post.value?.user_type : 'community_admin'
                }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(UserAliasIcon, {
                    userType: __props.userPost ? post.value?.user_type : 'community_admin',
                    class: "fw-bold"
                  }, null, 8, ["userType"]),
                  (!__props.userPost)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(post.value?.display_name), 1))
                    : (post.value?.user_type === 'community_admin' && __props.userPost)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "fs-7 fw-bold cursor-pointer",
                          onClick: _cache[0] || (_cache[0] = () => handleShowUser(_unref(route).params.id, post.value?.management_no, post.value.user_type, post.value?.is_deleted_in_30_days))
                        }, _toDisplayString(post.value?.management_no + ' ' + _unref(ReplayName)(post.value?.is_deleted_in_30_days, post.value?.available, post.value?.family_name, post.value?.given_name, post.value?.user_type)) + " " + _toDisplayString(post.value?.user_type == 'alumni' && [0, 1].includes(post.value?.is_deleted_in_30_days) ? `（ ${post.value?.display_name} ）` : ''), 1))
                ]),
                (post.value?.content_type !== 5)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(ChangeTime)(post.value?.created_at)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(post.value?.published_date ? _unref(ChangeTime)(post.value?.published_date) : '-'), 1))
              ])
            ])
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            ref: ref,
            class: "rounded-4 p-3"
          }, [
            _createElementVNode("div", _hoisted_14, [
              (post.value?.content_type !== 4)
                ? (_openBlock(), _createBlock(Category, {
                    key: 0,
                    content_type: post.value?.content_type
                  }, null, 8, ["content_type"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                (post.value?.content_type !== 4)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_16, _toDisplayString(post.value?.title), 1))
                  : _createCommentVNode("", true),
                (post.value?.content_type === 5 && _unref(communitySitePostContent)?.image_url)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_unref(communitySitePostContent)?.image_wrap_class_name)
                        }, [
                          _createElementVNode("img", {
                            src: _unref(communitySitePostContent)?.image_url,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (openUrlAssignToImage(_unref(communitySitePostContent)?.url_assign_to_image))),
                            alt: "post image",
                            class: "mb-4 cursor-pointer img-autopost",
                            width: _unref(communitySitePostContent)?.image_size?.width || null,
                            height: _unref(communitySitePostContent)?.image_size?.height || null
                          }, null, 8, _hoisted_19)
                        ], 2)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_20, [
                  (post.value?.content_type !== 5)
                    ? (_openBlock(), _createBlock(TargetTag, {
                        key: 0,
                        data: post.value?.content,
                        className: post.value?.content_type === 4 ? 'fw-bold·text-center··mt-5·mt-mb-3·fs-5' : ''
                      }, null, 8, ["data", "className"]))
                    : _createCommentVNode("", true),
                  (post.value?.content_type === 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_router_link, {
                          to: "",
                          class: "text-decoration-none text-black fs-7 fw-bold rounded-pill px-5 py-2 shadow border"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(post.value?.display_name) + " のプロフィール", 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (post.value?.content_type === 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", {
                              innerHTML: _unref(communitySitePostContent)?.content
                            }, null, 8, _hoisted_25)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (post.value?.content_type === 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (post.value.is_community_site_deleted)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                          : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                      ]))
                    : _createCommentVNode("", true),
                  (post.value && showUrlInConfirmDialog() && post.value?.content_type !== 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createVNode(UrlDisplay, {
                          "site-url": post.value.site_url_1,
                          "site-name": post.value.site_name_1
                        }, null, 8, ["site-url", "site-name"]),
                        _createVNode(UrlDisplay, {
                          "site-url": post.value.site_url_2,
                          "site-name": post.value.site_name_2
                        }, null, 8, ["site-url", "site-name"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["text-center", post.value?.content_type !== 4 && post.value?.content_type !== 5 ? 'mt-4' : ''])
                }, [
                  (post.value?.image_url && post.value?.content_type !== 5)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(addPostParams)(post.value?.image_url, post.value?.content_type),
                        alt: "post image",
                        class: "img-url mb-4"
                      }, null, 8, _hoisted_34))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_35, [
                  (post.value?.content_type !== 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.value?.tags, (tag) => {
                          return (_openBlock(), _createBlock(HashTag, {
                            key: tag.id,
                            tag: tag,
                            class: "me-2 mb-2"
                          }, null, 8, ["tag"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createVNode(LikeButton, {
                          class: "me-2",
                          count: post.value?.like_count,
                          like: post.value?.like,
                          id: post.value?.id,
                          type: 'like',
                          handleLikeOrInterest: () => checkUserDeleted(post.value) && handleLikeOrInterest('like', post.value?.id),
                          loadingLike: loadingLike.value
                        }, null, 8, ["count", "like", "id", "handleLikeOrInterest", "loadingLike"]),
                        (post.value?.content_type !== 4 && post.value?.content_type !== 1 && post.value?.content_type !== 5)
                          ? (_openBlock(), _createBlock(LikeButton, {
                              key: 0,
                              count: post.value?.interest_count,
                              interest: post.value?.interest,
                              id: post.value?.id,
                              type: 'interest',
                              handleLikeOrInterest: () => checkUserDeleted(post.value) && !post.value?.interest && __props.onInterestClick(),
                              loadingLike: loadingLike.value
                            }, null, 8, ["count", "interest", "id", "handleLikeOrInterest", "loadingLike"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (post.value?.file_url && post.value?.content_type !== 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("p", _hoisted_41, _toDisplayString(post.value?.file_url.split('/').slice(-1)[0]), 1)
                        ]),
                        _createVNode(PostFileDownload, {
                          className: "rounded-circle cursor-pointer",
                          communityId: post.value.community_id,
                          postId: post.value.id,
                          fileDownloadName: post.value?.file_url.split('/').slice(-1)[0],
                          fromAdminSite: true
                        }, null, 8, ["communityId", "postId", "fileDownloadName"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(UserComments, {
              comments: postComment.value,
              comment_count: post.value?.comment_count,
              postId: post.value?.id,
              mention_users: __props.listUser,
              onSetCommentData: setCommentData,
              onShowDeleteCommentModal: showDeleteCommentModal,
              onShowUpdateCommentErrorModal: showUpdateCommentErrorModal,
              onShowUpdateStatusCommentModal: showUpdateStatusCommentModal,
              id_comment: idComment.value
            }, null, 8, ["comments", "comment_count", "postId", "mention_users", "id_comment"]),
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createVNode(LikeButton, {
                    class: "me-2",
                    count: post.value?.like_count,
                    like: post.value?.like,
                    id: post.value?.id,
                    type: 'like',
                    handleLikeOrInterest: () => checkUserDeleted(post.value) && handleLikeOrInterest('like', post.value?.id),
                    loadingLike: loadingLike.value,
                    user_type: post.value?.user_type
                  }, null, 8, ["count", "like", "id", "handleLikeOrInterest", "loadingLike", "user_type"]),
                  (post.value?.content_type !== 4 && post.value?.content_type !== 1)
                    ? (_openBlock(), _createBlock(LikeButton, {
                        key: 0,
                        count: post.value?.interest_count,
                        interest: post.value?.interest,
                        id: post.value?.id,
                        type: 'interest',
                        handleLikeOrInterest: () => checkUserDeleted(post.value) && !post.value?.interest && __props.onInterestClick(),
                        loadingLike: loadingLike.value,
                        user_type: post.value?.user_type
                      }, null, 8, ["count", "interest", "id", "handleLikeOrInterest", "loadingLike", "user_type"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(Comment, {
              post: post.value,
              create_by_admin: post.value?.create_by_admin,
              reset: reset.value,
              admin: true,
              users: _unref(mentionUsers),
              titleMention: _unref(titleMention)
            }, null, 8, ["post", "create_by_admin", "reset", "users", "titleMention"]),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(Button, {
                title: _unref(translate)('close'),
                type: 'secondary',
                "data-bs-dismiss": "modal"
              }, null, 8, ["title"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})